// Reveals the sticky header search once the hero search scrolls out of view.
export const HeaderSearchReveal = {
  mounted() {
    const hero = document.getElementById("hero-search-form");
    if (!hero) return this.show();

    this.observer = new IntersectionObserver(([entry]) => {
      entry.isIntersecting ? this.hide() : this.show();
    });
    this.observer.observe(hero);
  },
  // LiveView patches restore the server-rendered (hidden) classes; re-assert
  // the client-side state so the search doesn't vanish on re-render.
  updated() {
    if (this.revealed === true) this.show();
    if (this.revealed === false) this.hide();
  },
  destroyed() {
    if (this.observer) this.observer.disconnect();
  },
  // inert keeps the invisible search out of the tab order while hidden.
  show() {
    this.revealed = true;
    this.el.inert = false;
    this.el.classList.remove("opacity-0", "pointer-events-none");
  },
  hide() {
    this.revealed = false;
    this.el.inert = true;
    this.el.classList.add("opacity-0", "pointer-events-none");
  },
};
